import { z } from 'zod';
export const HealthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    service: z.string(),
    version: z.string(),
    uptime: z.number().nonnegative(),
    timestamp: z.string().datetime(),
});
//# sourceMappingURL=health.js.map